function resizeBloc(){
    setTimeout(function(){
        var bloc_right_height = $('.wrap-bloc-right').outerHeight();
        var background_shop = $('.wrap-bloc-left').outerHeight();

        if (bloc_right_height > background_shop) {
            var new_height = bloc_right_height + 50;
        } else {
            var new_height = background_shop + 50;
        }

        $('.header-category-shop').css('height', new_height+"px");
    }, 300)

    /*
        Apply hover animation on product in category page
        L'animatin passe par du js pour ne pas avoir l'animation s'il n'y a pas d'image hover
    */
    const productWrap = document.querySelectorAll('.woocommerce-loop-product__link');

    productWrap.forEach((item) => {
        const imageHover = item.querySelector('.image-product__hover');
        if (imageHover) {
            item.addEventListener('mouseenter', () => {
                item.classList.add('js-is-hover');
            });
            item.addEventListener('mouseleave', () => {
                item.classList.remove('js-is-hover');
            });
        }
    });
}

module.exports = function () {
    window.addEventListener('load ready resize', resizeBloc);
    resizeBloc();
};
